import { useInstantWinsStore } from '@/stores/instant-wins'
import type { RouteLocation } from 'vue-router'

/**
 * Fetch instant wins in the background on all route navigations.
 * This guard doesn't block navigation - it starts the fetch and lets
 * components show skeleton loaders while data is being fetched.
 *
 * The store has built-in caching, so subsequent calls return immediately.
 */
export const fetchInstantWins = async (_to: RouteLocation) => {
  const instantWinsStore = useInstantWinsStore()

  // Fetch instant wins in the background (non-blocking)
  // The store method already has caching built-in, so this is cheap
  instantWinsStore.fetchInstantWins().catch((error) => {
    console.error('Failed to fetch instant wins:', error)
    // Don't block navigation on error
  })
}
